module.exports = __webpack_public_path__ + "media/src/shared_components/close-33d8f9df2593535cbc03e4ea1a2ded20.svg";